// extracted by css-extract-rspack-plugin
export default {"avatar":"avatar-eefXo8","sm":"sm-SLoKEl","primary":"primary-qnvq5V","subtle":"subtle-h0CQoB"};